/*
 * --------------------------------------------------------------------------- *
 * File: field.js                                                              *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useEffect } from "react";
import "../App.css";

import Constants from "../main/constants";
import CheckBox from "./checkboxfield";
import { checkNameExists, getDataTypeDetails } from "./datatypeutils";
import DateField from "./datefield";
import SelectField from "./selectfield";
import ListField from "./listfield";
import TextField from "./textfield";
import DataForm from "./dataform";
import AddressField from "./addressfield";

function Field(props) {
  const renderElement = (i, e, value, onChange) => {
    if (e.validation) {
      props.validation.add(e.validation);
    }
    if (
      e.fieldType === Constants.DATA_TYPE_TEXT ||
      e.fieldType === Constants.DATA_TYPE_NUMBER ||
      e.fieldType === Constants.DATA_TYPE_PASSWORD
    ) {
      return <TextField key={i} type={e} value={value} onChange={onChange}></TextField>;
    } else if (e.fieldType === Constants.DATA_TYPE_ADDRESS) {
      return <AddressField key={i} value={value} type={e} onChange={onChange} />;
    } else if (e.fieldType === Constants.DATA_TYPE_CHECKBOX) {
      return <CheckBox key={i} value={value} type={e} onChange={onChange} />;
    } else if (e.fieldType === Constants.DATA_TYPE_DATE) {
      return <DateField key={i} value={value} type={e} onChange={onChange} />;
    } else if (e.fieldType === Constants.DATA_TYPE_SELECT) {
      return <SelectField key={i} value={value} type={e} onChange={onChange} />;
    } else if (e.fieldType === Constants.DATA_TYPE_LIST) {
      return (
        <div className="form-border p-2 m-1 rounded">
          <ListField
            key={i}
            divCss={e.divCss}
            value={value}
            title={e.fieldTitle}
            subType={e.subType}
            onChange={onChange}
          />
        </div>
      );
    } else if (Array.isArray(e.fieldType)) {
      return (
        <div className={e.divCss}>
          <div className="form-border p-2 m-1 rounded">
            <DataForm
              key={i}
              title={e.fieldTitle}
              structure={e.fieldType}
              data={value}
              onChange={onChange}
              validation={props.validation}
            />
          </div>
        </div>
      );
    } else if (checkNameExists(e.fieldType)) {
      return (
        <div className={e.divCss}>
          <div className="form-border p-2 m-1 rounded">
            <DataForm
              key={i}
              title={e.fieldTitle}
              structure={getDataTypeDetails(e.fieldType).structure}
              data={value}
              onChange={onChange}
              validation={props.validation}
            />
          </div>
        </div>
      );
    } else {
      console.log(e.fieldType);
      return <></>;
    }
  };

  try {
    return renderElement(props.index, props.type, props.value, props.onChange);
  } catch (e) {
    console.log(e);
    return <></>;
  }
}

export default Field;
